module.exports = __webpack_public_path__ + "img/f25.4fe5e2ac.png";